import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 
import Box from '@mui/material/Box';
import PlanInfo from './plans/PlanInfo';
import Invoices from './invoices/Invoices';
import PaymentMethod from './items/PaymentMethod';
import Seats from './items/Seats';
import CancelSubscription from './items/CancelSubscription';
import RenewSubscription from './items/RenewSubscription';
import Section from '../../general/containers/Section';

interface Props { 

}; 

const Billing: React.FC<Props> = ({ }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const subscription = useAppSelector(state => state.billing.subscription); 

    const navBarHeight = '5vh';
    const sideBarWidth = '70px';

    return (
        <Section
            extraStyle={{
                position: 'absolute',
                top: navBarHeight,
                left: sideBarWidth,
                width: `calc(100% - ${sideBarWidth})`,
                height: `calc(100% - ${navBarHeight})`,
                boxSizing: 'border-box',
                overflow: 'auto',
                padding: '2rem',
                backgroundColor: colors?.container,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '2rem'
            }}
        >
            <PlanInfo /> 
            <RenewSubscription />
            {(subscription?.status === 'active') && <Seats />}
            <PaymentMethod />
            <Invoices />
            <CancelSubscription />
        </Section>
    );
};

export default Billing;